module.exports = __webpack_public_path__ + "static/media/GeraldtonGuardian-devicecomp-min@2x.34035afd.webp";